import { render } from "./DurationSound.vue?vue&type=template&id=3ff606f0"
import script from "./DurationSound.vue?vue&type=script&lang=js"
export * from "./DurationSound.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__